import o from"./fails.js";var r=o,e=!r(function(){function t(){}return t.prototype.constructor=null,Object.getPrototypeOf(new t)!==t.prototype});export{e as default};
